import $ from "./adminBase";
import { service } from "../base";

export default {
  login({ userName, password }) {
    return $.post(`/login?userName=${userName}&password=${password}`);
  },
  logout() {
    return $.get("/logout");
  },

  userList(data) {
    return $.get("/sys/user/page", data);
  },
  userDataById() {},
  addUser(data) {
    return $.post("/sys/user/add", data);
  },
  updateUser(data) {
    return $.put("/sys/user/add", data);
  },
  delUser(id) {
    return $.delete("/sys/user/del/" + id);
  },

  menuPromise(data) {
    return $.get("/system/menu/perms", data);
  },

  payMember(data) {
    // 开通会员
    return $.post(`/wx/pay/member`, data);
  },

  //  查询会员套餐
  memberList() {
    return $.get(`/member/menu/list`);
  },

  //  查询会员套餐
  appendList() {
    return $.get(`/member/append/list`);
  },
  //  获取会员信息
  vipInfo() {
    return $.get(`/member/menu/get/userMenu`);
  },

  //  获取订单状态
  orderInfo(id) {
    return $.get(`/wx/pay/orderInfo?orderId=${id}`);
  },

  //  获取体验会员二维码
  vipCode() {
    return $.get(`/birthday/back/identifying/code/getCode`);
  },

  // 兑换体验会员
  exchangeVip(code) {
    return $.post(`/wx/pay/freeMember?code=${code}`);
  },

  //  获取当前用户天气币余额
  userIncome() {
    return $.get(`/wx/pay/userIncome`);
  },

  //  天气比兑换下载次数
  integralExportData(data) {
    return service.post(`/device/stat/user/account/export/data/v2`, data);
  },

  updateUser2(data) {
    //type:9 all access;
    return $.post("/user/update", data);
  },
};
